import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "法苑在线", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "法苑在线", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_5 = {
  class: "slide_menu",
  style: {"position":"fixed","top":"60px","right":"0px","height":"400px","width":"120px","background":"rgba(0,0,0,0.3)"}
}

import { ref, watch ,onMounted} from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    sideMenulist: {
        type: Array,
        required: true,
    },
    selectId: {
        type: String,
    },
},
  emits: ["scrollId"],
  setup(__props, { expose: __expose, emit: __emit }) {


const logoImg = require("../assets/logo.png");
const menuImg = require("../assets/menu.png");
const activeIndex = ref("1");
const emit = __emit;
// watch(selectId,(newVal)=>{
//   console.log(newVal)
//   activeIndex.value =selectId
// },{deep:true,immediate:true})

const handleSelect = (key: number, keyPath: string[]) => {
  console.log(key, keyPath);
  // emit("toParentid", key);
  emit("scrollId",key)
};
const handleSelect2 = (key: number, keyPath: string[]) => {
  console.log(key, keyPath);
  emit("scrollId",key)
  isShow.value = false
};
let isShow = ref<boolean>(false)
const handleShow= () => {
  isShow.value = !isShow.value
};
let bgColor = ref < string > (`rgb(40,120,123)`);

// 动态设置背景色透明度
const setBgColor = (v: number) => {
    bgColor.value = `rgba(40,120,123,${v})`;
};
__expose({ setBgColor }); //内部方法，供外部调用
let ismx = ref<boolean>()

const scrollWidth = ref<number>(0)
const widthHandle = () => {
  scrollWidth.value = document.body.clientWidth; //滚动条距离浏览器顶部高度

};
onMounted(() => {
  widthHandle()
  if(scrollWidth.value > 1299){
    ismx.value = true
  }else{
    ismx.value = false
  }
  window.addEventListener("resize", widthHandle);
});
watch(
    () => scrollWidth.value,
    (newValue, oldValue) => {
      console.log(newValue,oldValue)
      setTimeout(() => {
        if(newValue > 1299){
          ismx.value = true
        }else{
          ismx.value = false
        }
      }, 20); // 需要使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms

    }
)

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(ismx))
      ? (_openBlock(), _createBlock(_component_el_menu, {
          key: 0,
          "default-active": activeIndex.value,
          "active-text-color": "#fff",
          "text-color": "#fff",
          "background-color": _unref(bgColor),
          class: "el-menu-demo",
          mode: "horizontal",
          ellipsis: false,
          onSelect: handleSelect,
          style: {"padding":"0 30px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, {
              index: "0",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  style: {"width":"54px","height":"54px"},
                  src: _unref(logoImg),
                  fit: "fill"
                }, null, 8, ["src"]),
                _hoisted_1
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_component_el_menu_item, {
              index: "1",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("首页")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "2",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("产品与服务")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "3",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("律师入驻")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "4",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("企业入驻")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "5",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("法律培训")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "6",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("渠道合作")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "7",
              class: "header-font"
            }, {
              default: _withCtx(() => [
                _createTextVNode("关于我们")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active", "background-color"]))
      : _createCommentVNode("", true),
    (!_unref(ismx))
      ? (_openBlock(), _createBlock(_component_el_menu, {
          key: 1,
          "default-active": activeIndex.value,
          "active-text-color": "#fff",
          "text-color": "#fff",
          "background-color": _unref(bgColor),
          class: "el-menu-demo2",
          mode: "horizontal",
          ellipsis: false,
          onSelect: handleSelect2,
          style: {"padding":"0 4px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, {
              index: "0",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  class: "min_logo",
                  src: _unref(logoImg),
                  fit: "fill"
                }, null, 8, ["src"]),
                _hoisted_3
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_el_image, {
              class: "min_menu",
              src: _unref(menuImg),
              fit: "fill",
              onClick: handleShow
            }, null, 8, ["src"]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_menu_item, {
                index: "1",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "2",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("产品与服务")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "3",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("律师入驻")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "4",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("企业入驻")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "5",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("法律培训")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "6",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("渠道合作")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "7",
                class: "header-font"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("关于我们")
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _unref(isShow)]
            ])
          ]),
          _: 1
        }, 8, ["default-active", "background-color"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})